import React, { useState } from 'react';
import api from '../api';
import { saveAuth } from '../auth';


const styles = {
  container: {
    maxWidth: 480,
    margin: '0 auto',
    minHeight: '100vh',
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '2rem 1.5rem',
  },
  logo: {
    fontSize: 28,
    fontWeight: 700,
    marginBottom: 8,
    color: '#1a1a1a',
  },
  subtitle: {
    fontSize: 15,
    color: '#888',
    marginBottom: '2.5rem',
  },
  tabRow: {
    display: 'flex',
    marginBottom: '1.5rem',
    borderBottom: '1px solid #f0f0f0',
  },
  tab: {
    flex: 1,
    padding: '10px 0',
    fontSize: 15,
    fontWeight: 500,
    background: 'none',
    border: 'none',
    color: '#aaa',
    cursor: 'pointer',
    borderBottom: '2px solid transparent',
    marginBottom: -1,
  },
  tabActive: {
    flex: 1,
    padding: '10px 0',
    fontSize: 15,
    fontWeight: 600,
    background: 'none',
    border: 'none',
    color: '#1a1a1a',
    cursor: 'pointer',
    borderBottom: '2px solid #1a1a1a',
    marginBottom: -1,
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
    color: '#888',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    marginBottom: 6,
    marginTop: 16,
    display: 'block',
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    border: '1px solid #ebebeb',
    borderRadius: 10,
    fontSize: 15,
    background: '#fff',
    color: '#1a1a1a',
    outline: 'none',
  },
  btn: {
    display: 'block',
    width: '100%',
    padding: '14px',
    marginTop: '1.5rem',
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
    background: '#1a1a1a',
    border: 'none',
    borderRadius: 12,
    cursor: 'pointer',
  },
  error: {
    marginTop: '1rem',
    padding: '10px 14px',
    background: '#fff5f5',
    border: '1px solid #f5c0c0',
    borderRadius: 8,
    fontSize: 13,
    color: '#c0392b',
  },
};

export default function AuthScreen({ onAuth }) {
  const [mode, setMode] = useState('login');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');
    setLoading(true);
    try {
      if (mode === 'register') {
        const res = await api.post('/register', {
          username, email, password,
        });
        const userRes = await api.get('/me', {
          headers: { Authorization: `Bearer ${res.data.access_token}` }
        });
        saveAuth(res.data.access_token, userRes.data);
        onAuth(userRes.data);
      } else {
        const params = new URLSearchParams();
        params.append('username', username);
        params.append('password', password);
        const res = await api.post('/token', params);
        const userRes = await api.get('/me', {
          headers: { Authorization: `Bearer ${res.data.access_token}` }
        });
        saveAuth(res.data.access_token, userRes.data);
        onAuth(userRes.data);
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.logo}>Gym Tracker</div>
      <div style={styles.subtitle}>Track your gains, see your progress.</div>

      <div style={styles.tabRow}>
        <button
          style={mode === 'login' ? styles.tabActive : styles.tab}
          onClick={() => { setMode('login'); setError(''); }}
        >
          Log in
        </button>
        <button
          style={mode === 'register' ? styles.tabActive : styles.tab}
          onClick={() => { setMode('register'); setError(''); }}
        >
          Register
        </button>
      </div>

      <label style={styles.label}>Username</label>
      <input
        style={styles.input}
        placeholder="username"
        value={username}
        onChange={e => setUsername(e.target.value)}
        autoCapitalize="none"
        autoCorrect="off"
      />

      {mode === 'register' && (
        <>
          <label style={styles.label}>Email</label>
          <input
            style={styles.input}
            placeholder="you@email.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            type="email"
            autoCapitalize="none"
          />
        </>
      )}

      <label style={styles.label}>Password</label>
      <input
        style={styles.input}
        placeholder="••••••••"
        value={password}
        onChange={e => setPassword(e.target.value)}
        type="password"
      />

      {error && <div style={styles.error}>{error}</div>}

      <button style={styles.btn} onClick={handleSubmit} disabled={loading}>
        {loading ? '...' : mode === 'login' ? 'Log in' : 'Create account'}
      </button>
    </div>
  );
}